(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[326],{

/***/ 2536:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[site]/news/[categorySlug]",
      function () {
        return __webpack_require__(350);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 350:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var helpers_uppercaseFirst__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(406);
/* harmony import */ var components_Layout__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3825);
/* harmony import */ var components_WordpressSEO__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1610);
/* harmony import */ var components_NewsHeader__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9753);
/* harmony import */ var components_ArticleGrid__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6253);
/* harmony import */ var components_Pagination__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(919);








function Category(param) {
    var offsetPagination = param.offsetPagination, globalSettings = param.globalSettings, categorySlug = param.categorySlug, site = param.site, posts = param.posts, categoriesMenu = param.categoriesMenu;
    var ref, ref1, ref2;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_Layout__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        globalSettings: globalSettings,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_WordpressSEO__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                url: "/".concat(site, "/news/").concat(categorySlug),
                title: (0,helpers_uppercaseFirst__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(categorySlug),
                desc: "Latest news from our talent and models at Select Model London. Select Model Management is an iconic global network of boutique model and talent agencies.",
                image: posts === null || posts === void 0 ? void 0 : (ref = posts[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.acfPost) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.featuredImage) === null || ref2 === void 0 ? void 0 : ref2.mediaItemUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_NewsHeader__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                categorySlug: categorySlug,
                categories: categoriesMenu
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_ArticleGrid__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                articles: posts
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Pagination__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                pagination: offsetPagination,
                currentPage: 1
            })
        ]
    });
}
Category.propTypes = {
    globalSettings: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().object)
};
Category.defaultProps = {
    globalSettings: {}
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (Category);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [333,216,462,774,888,179], function() { return __webpack_exec__(2536); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);